import { map } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

import { ApiService } from "../shared/utilities/api.service";
import { Community, CommunityListConfig } from "../../models";
import { CommunityListResult } from "../../interfaces";

@Injectable()
export class CommunityService {
  constructor(private apiService: ApiService) {}

  public findOne(communityName: string): Observable<Community> {
    // GET /api/communities/:community
    const getURL = `/communities/${communityName}`;

    return this.apiService
      .get(getURL)
      .pipe(map((data: { community: Community }) => data.community));
  }

  public saveOne(community: Community): Observable<Community> {
    const communityName = community.name;
    const putURL = `/communities/${communityName}`;
    const postURL = `/communities`;

    // If we're updating an existing community
    // PUT /api/communities/:community
    if (community.id) {
      return this.apiService
        .put(putURL, { community: community })
        .pipe(map((data) => data.community));
    }
    // Otherwise, create a new community
    // POST /api/communities
    else {
      return this.apiService
        .post(postURL, { community: community })
        .pipe(map((data) => data.community));
    }
  }

  public deleteOne(community: Community, credentials: any) {
    // POST /api/communities/delete/:community
    const communityName = community.name;
    const deleteURL = `/communities/delete/${communityName}`;

    return this.apiService.post(deleteURL, { user: credentials });
  }

  public findMany(
    config: CommunityListConfig
  ): Observable<CommunityListResult> {
    let params = {};

    Object.keys(config.filters).forEach((key) => {
      params[key] = config.filters[key];
    });

    // GET /api/communities?tag=NodeJS
    const getURL = "/communities";

    var finalParams = new HttpParams({ fromObject: params });
    return this.apiService.get(getURL, finalParams).pipe(map((data) => data));
  }

  public searchOne(
    config: CommunityListConfig
  ): Observable<CommunityListResult> {
    let params = {};

    Object.keys(config.filters).forEach((key) => {
      params[key] = config.filters[key];
    });

    // GET /api/communities/search/keywords
    const getURL = "/communities/search/keywords";
    var finalParams = new HttpParams({ fromObject: params });

    return this.apiService.get(getURL, finalParams).pipe(map((data) => data));
  }
}
